import { useEffect, useRef, useState } from "react";

import { draggable } from "@atlaskit/pragmatic-drag-and-drop/element/adapter";

import { ElementButton, ElementButtonProps } from "./elementButton";
import * as theme from "./theme.css";
import { DraggedButton, ITEM_TYPES } from "./types";

export function DraggableElementButton<ElementButtonSpecId extends string>(
    props: Omit<
        ElementButtonProps<ElementButtonSpecId>,
        "draggable" | "isDragging"
    >
) {
    const ref = useRef<HTMLDivElement>(null);
    const [isDragging, setIsDragging] = useState(false);

    // Register the button as draggable; flag isDragging for visual feedback.
    useEffect(() => {
        const el = ref.current;
        console.log("1", el);
        if (!el) {
            return;
        }
        const data: DraggedButton<ElementButtonSpecId> = {
            type: ITEM_TYPES.BUTTON,
            id: props.id,
        };
        return draggable({
            element: el,
            getInitialData: () => ({ ...data }),
            onDragStart: () => setIsDragging(true),
            onDrop: () => setIsDragging(false),
        });
    }, [props.id]);

    return (
        <div ref={ref} className={theme.draggableButtonContainer}>
            <ElementButton
                draggable={true}
                isDragging={isDragging}
                icon={props.icon}
                id={props.id}
                label={props.label}
                onClick={props.onClick}
                renderPlaceholder={props.renderPlaceholder}
            />
        </div>
    );
}
